import { Fragment } from "react";

const FormButton = (props) => {
    const primaryState = "text-text-inverse px-8 mx-2 py-1.5 border border-transparant border-solid bg-primary font-medium hover:bg-primary-hover active:bg-primary-press cursor-pointer disabled:bg-surface-2 disabled:cursor-not-allowed disabled:text-text-3";
    const secondaryState = "bg-surface border border-solid border-border text-text px-8 mx-2 py-1.5 font-medium hover:bg-surface-2 active:border-border-strong cursor-pointer disabled:cursor-not-allowed disabled:text-text-3";
    const tertiaryState = "bg-surface border border-solid border-border text-text px-8 mx-2 py-1.5 font-medium hover:bg-surface-2 active:border-border-strong cursor-pointer disabled:cursor-not-allowed disabled:text-text-3";
    const dangerState = "text-white px-8 mx-2 py-1.5 bg-danger font-medium hover:opacity-90 cursor-pointer disabled:bg-surface-2 disabled:cursor-not-allowed disabled:text-text-3";
    const warningState = "text-white px-8 mx-2 py-1.5 bg-warning font-medium hover:opacity-90 cursor-pointer disabled:bg-surface-2 disabled:cursor-not-allowed disabled:text-text-3";

    const getButtonStyle = () => {
        if (props.style === "primary") return primaryState;
        if (props.style === "danger") return dangerState;
        if (props.style === "warning") return warningState;
        if (props.style === "secondary") return secondaryState;
        if (props.style === "tertiary") return tertiaryState;
        return secondaryState;
    };

    return (
        <Fragment>
            <button 
                id="dropdownDefaultButton" 
                data-dropdown-toggle="dropdown" 
                className={`${getButtonStyle()} mx-1 rounded-ctrl text-center text-base inline-flex items-center ${props.className}`}
                type={props.type}
                onClick={props.onClick}
                disabled={props.disabled}
                >
                {props.icon && <span className="mr-2">{props.icon}</span>}
                <div className="m-auto">{props.title}</div>
            </button>
        </Fragment>
    );
  };
  
  export default FormButton;